import styled, { css } from 'styled-components'
import theme from 'theme_'

export const CounterButton = styled.button`
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  padding: 0;
  margin: 0;
  background: ${(p) =>
    p.disabled ? 'transparent' : theme.colors.horizonOrange};
  border-radius: 0px;
  color: ${theme.colors.white};
  border: 1px solid ${theme.colors.horizonOrange};
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};

  ${(p) =>
    p.disabled &&
    css`
      border: 0px solid ${theme.colors.pelicanGrey};
      background-color: ${theme.colors.pelicanGrey};
    `}
`

export const CounterWrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  flex-direction: row;
  border: ${(p) =>
    p.disabled
      ? `1px solid ${theme.colors.disabledGrey}`
      : `1px solid ${theme.colors.horizonOrange}`};
  border-radius: 4px;
  overflow: hidden;
`

export const CounterCount = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 48px;
  height: 32px;
  padding: 0px;
  color: ${theme.colors.otterWarmBlack};
  background: ${theme.colors.white};
  user-select: none;
`
